// CUSTOM CODE JAVASCRIPT, ATTRACTION STUDIO


// Homepage, background image parallax
document.addEventListener("DOMContentLoaded", function () {
  const section = document.querySelector("#shopify-section-template--21451250532581__image_with_text_ByaYcJ");

  if (!section) return;

  // Create the parallax element
  const parallaxImg = document.createElement("div");
  parallaxImg.classList.add("parallax-bg");
  section.prepend(parallaxImg); // put behind content

  // Parallax effect on scroll
  window.addEventListener("scroll", () => {
    const sectionTop = section.getBoundingClientRect().top;
    const speed = 0.05; // smaller = slower movement
    parallaxImg.style.transform = `translateY(${ sectionTop * speed }px)`; // flipped sign for moving up
  });
});


// Stagger animation, Homepage

document.addEventListener("DOMContentLoaded", function () {
  const heading = document.querySelector(".inline-heading-rte.heading-feature");
  if (!heading) return;

  heading.style.visibility = "visible"; // show heading immediately before animating

  const words = heading.textContent.trim().split(" ");
  heading.textContent = "";

  words.forEach((word, index) => {
    const span = document.createElement("span");
    span.textContent = word;

    // Make spacing and inline-block for proper layout
    span.style.display = "inline-block";
    span.style.marginRight = "0.8rem"; // <-- adjust spacing here
    if (index === words.length - 1) {
      span.style.marginRight = "0"; // no extra space after last word
    }

    // Animation
    span.style.animation = `fadeInUp 0.6s forwards`;
    span.style.animationDelay = `${0.4 + index * 0.2}s`; // stagger

    heading.appendChild(span);
  });
});

// Loyalty Button Pick Me (only on /pages/loyalty-club)
document.addEventListener("DOMContentLoaded", function () {

  // Only run on loyalty page
  if (window.location.pathname !== "/pages/loyalty-club") return;

  document.addEventListener("click", function (e) {

    const trigger = e.target.closest(".push-btn");
    if (!trigger) return;

    const launcher = document.querySelector(".cp-launcher-btn");
    if (!launcher) return;

    e.preventDefault(); // pause redirect so animation is visible

    // Add jump animation class
    launcher.classList.add("pickme");

    // Remove after animation and continue navigation
    setTimeout(function () {
      launcher.classList.remove("pickme");
      window.location.href = trigger.href;
    }, 800); // matches animation duration

  });

});

// Homepage & Specific Collection Footer Squiggle
document.addEventListener("DOMContentLoaded", function () {
  const path = window.location.pathname;

  if (
    path === "/" ||
    path === "" ||
    path === "/collections/pies" ||
    path === "/collections/sweet-treats" ||
    path === "/collections/bulk-catering"
  ) {
    const shapeDivider = document.getElementById("shape-divider-shape_divider_Cex9xh");
    if (shapeDivider) {
      shapeDivider.style.display = "none";
    }
  }
});